import { closeSesion } from "../system.helper";

const commandFunctions = {
    CLOSE_SESSION: (event) => {
        closeSesion();
    },
};

export { commandFunctions };